import type { FaireProductEntity } from "../../entity_types/product";

export const p_42n546c9et: FaireProductEntity = {
  token: "p_42n546c9et",
  type: "product",
  name: "Women's Wig Full Head Dark Brown Ombre Wavy Long Hair",
  brandToken: "b_n77n5vays8",
  brandName: "kycozy",
  imageUrl:
    "https://cdn.faire.com/fastly/28747b0f2a684a22159690fe82bb0d7e1b7fe96a5735ddec4dbf16017b95a338.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c41755266df4e7448538fd5df62197c284616e8565975fb2f1128dde4acae29.jpeg",
    "https://cdn.faire.com/fastly/d3414fa15e3b6c017321f1d043a21e50653bd363d5d40fe9b9a368f46c919873.jpeg",
    "https://cdn.faire.com/fastly/e1bd9edfca10cfd05cbd19742a54eafc4ca96705a797928eec9b1f8a892c8b74.jpeg",
  ],
  priceDollars: 20.99,
  description:
    "Kycozy brings you the Women's Wig Full Head Dark Brown Ombre Wavy Long Hair. This wig transforms your look in an instant, offering a beautiful dark brown ombre and wavy long hair. Whether you're changing up your style or want a confidence boost, this wig is an excellent choice. With Kycozy, we ensure a unique and fun shopping experience.",
  tags: [],
  msrpDollars: 41.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:53.920Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
